// Constants
import { SIGNING_PROCESSING_TYPE } from "../../../constants/ManualRequestFormConstants";
import { config } from "../config";
import axios from "axios";

const getRemoteIdentURL = async (requestId) => {
  const url = `${config.apiUrl}/qes/${requestId}/remote-ident`;

  try {
    const resp = await axios.put(url);
    return resp;
  } catch (error) {
    return error;
  }
};

// Download Documents Status in JP Vollmacht
async function getPrefilledDocumentStatus(requestId) {
  const url = `${config.apiUrl}/qes/${requestId}/prefilled-docs/validation`;

  try {
    const resp = await axios.get(url);
    return resp;
  } catch (error) {
    return error;
  }
}

// Download Documents in JP Vollmacht
async function getPrefilledDocumentsDownload(requestId) {
  const url = `${config.apiUrl}/qes/${requestId}/prefilled-docs`;

  try {
    const resp = await axios.get(url, {
      responseType: "blob",
    });
    return resp;
  } catch (error) {
    return error;
  }
}

const sendSignatureEmailDetails = async (
  vollmachtType,
  requestId,
  signedData
) => {
  const url = `${config.apiUrl}/${
    vollmachtType === SIGNING_PROCESSING_TYPE.QES ? "qes" : "dauervollmacht"
  }/${requestId}/prefilled-docs/email`;

  try {
    const resp = await axios.post(url, signedData);
    return resp;
  } catch (error) {
    return error;
  }
};

async function getQESProviders() {
  const url = `${config.apiUrl}/qes/providers`;

  try {
    const resp = await axios.get(url);
    return resp;
  } catch (error) {
    return error;
  }
}

// MOCK: replace with real endpoint — POST /qes/{requestId}/signing
// NP and JP signing flows differ per vendor; both are always sent.
const startQESSigning = async (requestId, vendorKey, personenform) => {
  return Promise.resolve({
    status: 200,
    data: {
      requestId,
      vendor: vendorKey,
      personenform,
      signingSessionId: "mock-signing-session",
      status: "STARTED",
    },
  });
};

export const vollmachtRequestFormService = {
  getRemoteIdentURL,
  getPrefilledDocumentStatus,
  getPrefilledDocumentsDownload,
  sendSignatureEmailDetails,
  getQESProviders,
  startQESSigning,
};
